import { db } from 'codemash';
import { Config } from '../configs';
import { mapApiToDataPaymentOption, mapApiToDataRestaurant } from './mappers/restaurant';
import { mapApiToDataTable } from './mappers/table';
import { manageApiUnavailableError } from './error/errors';
import { resourceRequest } from './client/requests';

export const getTableByQrCode = async ({ tableQr }) => {
  try {
    if (!tableQr) {
      return { table: null, restaurant: null, paymentOption: null };
    }

    // TODO: later replace this to v2 only
    // const response = await db.executeAggregate({
    //   id: Config.DATA.AGGREGATES.GET_TABLE_V2,
    //   collectionName: Config.DATA.COLLECTIONS.TABLES,
    //   database: Config.CODEMASH.DB_STORAGE_ID,
    //   tokens: {
    //     qr: tableQr,
    //   },
    // });
    const response = await resourceRequest({
      data: {
        id: 'ClientGetTableData',
        tokens: {
          qr: tableQr,
        },
      },
      action: 'aggregate',
    });

    // if () {
    //   response = await resourceRequest({
    //     data: {
    //       id: 'ClientGetTableData',
    //       tokens: {
    //         qr: tableQr,
    //       },
    //     },
    //     action: 'aggregate',
    //   });
    // } else {
    //   response = await db.executeAggregate({
    //     id: Config.DATA.AGGREGATES.GET_TABLE_V2,
    //     collectionName: Config.DATA.COLLECTIONS.TABLES,
    //     database: Config.CODEMASH.DB_STORAGE_ID,
    //     tokens: {
    //       qr: tableQr,
    //     },
    //   });
    // }

    if (response && response.length > 0) {
      return {
        table: mapApiToDataTable({ table: response[0] }),
        restaurant: mapApiToDataRestaurant({
          restaurant: response[0].restaurant,
          company: response[0].company,
        }),
        paymentOption: mapApiToDataPaymentOption({ options: response[0].payment_options }),
      };
    }
  } catch (e) {
    manageApiUnavailableError(e);

    if (Config.SHOW_LOGS) {
      console.log('Error while trying to get table by qr code', e);
    }
  }

  return { table: null, restaurant: null, paymentOption: null };
};
